export enum ControllerEventType {
    UP = "up",
    DOWN = "down",
    PRESS = "press"
}
